export const EARN_HERO_PARTICLES = [
  { tone: 'gold' as const, top: '14%', left: '8%', width: 5, height: 5, delay: '0s', duration: '7s' },
  { tone: 'ice' as const, top: '38%', left: '46%', width: 4, height: 4, delay: '1.4s', duration: '9s' },
  { tone: 'gold' as const, top: '72%', left: '14%', width: 5, height: 5, delay: '2.6s', duration: '8s' },
  { tone: 'white' as const, top: '22%', left: '64%', width: 3, height: 3, delay: '0.6s', duration: '10s' },
  { tone: 'gold' as const, top: '80%', left: '52%', width: 4, height: 4, delay: '3.2s', duration: '7.5s' },
  { tone: 'ice' as const, top: '60%', left: '88%', width: 3, height: 3, delay: '1.8s', duration: '9.5s' },
  { tone: 'white' as const, top: '28%', left: '32%', width: 3, height: 3, delay: '3.8s', duration: '11s' },
  { tone: 'gold' as const, top: '50%', left: '76%', width: 4, height: 4, delay: '2.0s', duration: '8.5s' },
];

export const EARN_RING_RADIUS = 68;
export const EARN_RING_CIRCUMFERENCE = 2 * Math.PI * EARN_RING_RADIUS;
